import { useState, useEffect } from "react";
import { Toaster } from "sonner";
import { Routes, Route } from "react-router-dom";

import { useAuth } from "./hooks/useAuth";
import { useSubdomain } from "./hooks/useSubdomain";
import LoginPage from "./views/LoginPage";
import AppRouter from "./AppRouter";
import SetupWizard from "./views/setup/SetupWizard";
import SchoolWebsite from './views/schoolwebsite/SchoolWebsite';
import { subscribeStudentOnLogin } from "./utils/pushNotifications";


/**
 * Entry point — only responsible for the auth gate.
 * All routing and data logic lives in AppRouter.
 */
export default function AppIndex() {
  const [lang, setLang] = useState("en");
  const { user, logout, sendOTP, verifyOTP, requiresSetup } = useAuth();
  const subdomain = useSubdomain();
  
  // Register service worker for push notifications
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker registered:', registration.scope);
        })
        .catch((error) => {
          console.log('Service Worker registration failed:', error);
        });
    }
  }, []);

  // Subscribe to push notifications when user logs in
  useEffect(() => {
    if (user) {
      // Small delay to ensure service worker is ready
      const timer = setTimeout(() => {
        subscribeStudentOnLogin(user);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [user]);

  // Redirect to setup wizard if required (only for admin users)
  useEffect(() => {
    const isAdmin = user?.role === 'admin' || user?.role === 'superadmin';
    if (user && isAdmin && requiresSetup && window.location.pathname !== '/setup-wizard') {
      window.location.href = '/setup-wizard';
    }
  }, [user, requiresSetup]);
  
  // Check if on setup wizard route
  const isSetupWizard = window.location.pathname === '/setup-wizard';
  
  return (
    <>
      <Toaster position="top-right" richColors closeButton />
      <Routes>
        <Route path="/s/:slug" element={<SchoolWebsite />} />
        <Route
          path="*"
          element={
            user ? (
              isSetupWizard ? (
                <SetupWizard />
              ) : (
                <AppRouter onLogout={logout} />
              )
            ) : (
              <LoginPage
                onSendOTP={sendOTP}
                onVerifyOTP={verifyOTP}
                lang={lang}
                setLang={setLang}
                subdomain={subdomain}
              />
            )
          }
        />
      </Routes>
    </>
  );
}